import {AfterViewInit, Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import { Permitions } from '../models/permitions';
import { SessionService } from '../services/session.service';
import { TxtConv } from '../helpers/txt-conv';

@Directive({
  selector: '[appBtnPermissionScope]'
})

export class ButtonActionsDirective implements OnInit {

  // region Atributos
  isVisible = false;
  permissionsModule: Permitions[];
  @Input() appBtnPermissionScope: Permitions;
  private corp: string;

  // endregion

  // region Constructor
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private userService: SessionService
  ) {
    //this.permissionsModule = this.userService.getPermitionsModules();

  }

  // endregion

  //region Métodos
  ngOnInit(): void {
    // Verificamos si tiene el permiso para ver el recurso
    this.checkStatus();
  }

  public checkStatus() {
    this.visibleTemplate();
    return;
    switch (TxtConv.txtCon(this.appBtnPermissionScope.module, 'uppercase')) {
      case 'USERSMANAGEMENT':
        switch (TxtConv.txtCon(this.appBtnPermissionScope.action, 'uppercase')) {
          case 'ADD':
            this.renderTemplete();
            break;
          case 'UPDATE':
            this.renderTemplete();
            break;
          case 'DELETE':
            this.renderTemplete();
            break;
          case 'INACTIVE':
            this.renderTemplete();
            break;
        } // check action
        break;
    } // check module
  }

  private renderTemplete() {
    if (this.appBtnPermissionScope) {
      for (let i = 0; i < this.permissionsModule.length; i++) {
        if (
          this.permissionsModule[i].module === TxtConv.txtCon(this.appBtnPermissionScope.module, 'uppercase') &&
          this.permissionsModule[i].action === TxtConv.txtCon(this.appBtnPermissionScope.action, 'uppercase')
        ) {
          this.visibleTemplate();
          return;
        }
      }
      this.hideTemplate();
    }
  }

  // Función privada para manejar si ya se aplico la directiva para crear el elemento embebido
  private visibleTemplate() {
    if (!this.isVisible) {
      this.isVisible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }

  }


  // Función para ocultar el elemento a la que se aplica la directiva
  private hideTemplate() {
    this.isVisible = false;
    this.viewContainerRef.clear();
  }

  //endregion

}
